<template>
    <v-container max-width="100%" style="margin-top: 2%">

        <v-container class="toolbar__container">
            <v-form ref="form" v-model="formValidado">
                <v-row>
                    <v-col cols="12" sm="6" md="3">
                        <LazySelect
                            get-url="getUnidadeslazy"
                            text="descricao_unidade"
                            value="id_unidade"
                            :label="$t('nav.registration.units')"
                            @input="onUnidadeSelect"
                        />
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                        <LazySelect
                            get-url="getGruposlazy"
                            text="nome"
                            value="id_grupo"
                            :label="$t('nav.registration.groups')"
                            @input="grupoSelecionado = $event"
                        />
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                        <LazySelect
                            ref="turnoSelect"
                            get-url="getTurnospassageiroslazy"
                            text="cod_turno"
                            value="id_turno"
                            :label="$t('nav.registration.shifts')"
                            :request-data="turnoLazyRequestData"
                            @input="turnoSelecionado = $event"
                        />
                    </v-col>
                    <v-col cols="12" sm="6" md="2">
                        <LazySelect
                            get-url="getStatusqrcodelazy"
                            :text="statusQrCodeText"
                            value="id_status_qrcode"
                            :label="$t('qrcodeAccessReport.status')"
                            @input="statusSelecionado = $event"
                        />
                    </v-col>
                    <v-col cols="12" sm="1" md="1" align="end">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn small fab color="primary darken-1" class="white--text" v-bind="attrs" v-on="on"
                                    @click="populaRelatorio" style="margin-bottom: 5px;">
                                    <v-icon>mdi-magnify</v-icon>
                                </v-btn>
                            </template>
                            <span>{{ $t('operation.search') }}</span>
                        </v-tooltip>
                    </v-col>
                </v-row>
            </v-form>
        </v-container>

        <MerusDataTable :headers="tableHeaders" :items="acessosFiltered" :loading="loading" :default-multi-sort="defaultSort"
            :loading-text="$t('qrcodeAccessReport.loading')"
            cod-tabela="RELACESSOQRCODE" @update:headers="headers = $event">
            <template v-slot:toolbar>
                <CadastroToolbar :title="$t('qrcodeAccessReport.title')" :token="token" :items="acessosFiltered"
                    csv-title="acessosqrcode" :pdf-title="$t('qrcodeAccessReport.title')" :pdf-headers="tableHeaders"
                    pdf-filename="acessosqrcode" hide-search>
                </CadastroToolbar>
            </template>
            <template v-slot:item.baixado="{ item }">
                <v-icon small class="mr-2" :color="item.baixado ? 'success' : 'red'">{{ item.baixado ? 'mdi-check' : 'mdi-close' }}</v-icon>
            </template>
            <template v-slot:item.acessado="{ item }">
                <v-icon small class="mr-2" :color="item.acessado ? 'success' : 'red'">{{ item.acessado ? 'mdi-check' : 'mdi-close' }}</v-icon>
            </template>
        </MerusDataTable>
    </v-container>

</template>
<script>

import apiController from '@/utils/apiController';
import MerusDataTable from "../components/Tables/MerusDataTable.vue"
import translateDbField from "@/utils/translateDbField"
import CadastroToolbar from './Toolbars/CadastroToolbar.vue';
import LazySelect from './Selects/LazySelect.vue';

export default {
    components: {
        MerusDataTable,
        CadastroToolbar,
        LazySelect,
    },
    data: () => ({
    headers: [],
        user: null,
        token: null,
        formValidado: false,
        unidadeSelecionada: null,
        grupoSelecionado: null,
        turnoSelecionado: null,
        statusSelecionado: null,
        search: "",
        acessos: [],
        loading: false,
    }),
    computed: {

        defaultSort() {
            return [
                { value: 'nome_completo', options: { text: this.$t('routs.increasing'), value: 1 } }];
        },
        defaultHeaders() {
            const col = (key, value, filtrable = true) => ({
                text: this.$t(`qrcodeAccessReport.headers.${key}`),
                value,
                sortable: true,
                filtrable,
                show: true,
            });
            return [
                col('registration', 'matricula'),
                col('name', 'nome_completo'),
                col('unit', 'cod_unidade'),
                col('group', 'nome_grupo'),
                col('shift', 'cod_turno'),
                col('accessed', 'acessado', false),
                col('downloaded', 'baixado', false),
                col('firstAccess', 'primeiro_acesso_qrcode_extenso'),
                col('lastAccess', 'ultimo_acesso_qrcode_extenso'),
                col('firstDownload', 'primeiro_download_qrcode_extenso'),
                col('lastDownload', 'ultimo_download_qrcode_extenso'),
            ];
        },
        tableHeaders() {
            return this.headers.length > 0 ? this.headers : this.defaultHeaders;
        },
        acessosFiltered() {
            let dados = this.acessos;
            
            if (this.unidadeSelecionada) {
                dados = dados.filter((d) => d.id_unidade === this.unidadeSelecionada);
            }

            if (this.grupoSelecionado) {
                dados = dados.filter((d) => d.id_grupo === this.grupoSelecionado);
            }

            if (this.turnoSelecionado) {
                dados = dados.filter((d) => d.id_turno === this.turnoSelecionado);
            }

            if (this.statusSelecionado) {
                dados = dados.filter((d) => d.id_status_qrcode === this.statusSelecionado);
            }

            return dados;
        },
        turnoLazyRequestData() {
            const id = this.unidadeSelecionada;
            if (id == null || id === '') {
                return {};
            }
            const n = Number(id);
            if (!Number.isFinite(n) || n <= 0) {
                return {};
            }
            return { id_unidades: [n] };
        },
    },
    created() {
        this.user = JSON.parse(sessionStorage.getItem("user"));
        this.token = sessionStorage.getItem("api");
    },
    methods: {
        onUnidadeSelect(val) {
            this.unidadeSelecionada = val;
            this.turnoSelecionado = null;
            this.$nextTick(() => {
                const ref = this.$refs.turnoSelect;
                if (ref && typeof ref.resetData === 'function') {
                    ref.resetData();
                }
            });
        },
        statusQrCodeText(item) {
            if (!item) return '';
            return translateDbField(item.translation_key, item.descricao_status_qrcode);
        },
        populaRelatorio() {
            this.loading = true;

            apiController.request(apiController.endpoints.getStatusqrcode, {
                onSuccess: (response) => {
                    this.acessos = response.data;
                    this.loading = false;
                },
                onError: (e) => {
                    this.loading = false;
                    this.erro = {
                        type: "Axios",
                        message: e.message,
                        status: e.response.status
                    };
                }
            });
        }
    }
}
</script>
<style lang="">

</style>
